import moment from "moment";
import { createCrudActions } from "../utils/crudGenerator";
import { axios } from "../connection/ConnectionHandler";
import { keyBy } from "lodash";
import { SET_BUDGET_LIST, SHOW_NOTIFICATION, UPDATE_BUDGET, BUDGET_FORM_TOOGLE_LOADING } from "../constants";
import { API } from "../constants/api";
const formatBudgets = (data) => {
	if (!data) {
		return [];
	}
	const formatItem = (item) => ({
		...item,
		label: `${item.name}`,
		value: item._id,
		date: item.date ? moment(item.date) : null,
		dueDate: item.dueDate ? moment(item.dueDate) : null,
	});

	if (Array.isArray(data)) {
		return data.map(formatItem);
	}
	return formatItem(data);
};

const getRequestErrorMessage = (err, fallback) => err?.response?.data?.message || err?.data?.message || err?.message || fallback;

export const {
	fetch: fetchBudgets,
	create: createBudget,
	update: updateBudget,
	delete: deleteBudgets,
} = createCrudActions("BUDGET", "Presupuesto", formatBudgets);

export const rejectBudget = (budget) => (dispatch) => {
	dispatch({ type: BUDGET_FORM_TOOGLE_LOADING });
	return axios
		.put(`/budget/${budget._id}`, { ...budget, rejected: true })
		.then((response) => {
			const formattedData = formatBudgets(response.data);
			dispatch({ type: UPDATE_BUDGET, payload: formattedData });
			dispatch({ type: BUDGET_FORM_TOOGLE_LOADING });
			dispatch({
				type: SHOW_NOTIFICATION,
				payload: {
					show: true,
					status: "success",
					message: "Presupuesto rechazado correctamente.",
				},
			});
			return response && response.status;
		})
		.catch((err) => {
			const errorMessage = err?.response?.data?.message || err?.data?.message || err?.message || "No se pudo rechazar el presupuesto";
			dispatch({ type: BUDGET_FORM_TOOGLE_LOADING });
			dispatch({
				type: SHOW_NOTIFICATION,
				payload: {
					show: true,
					status: "error",
					message: errorMessage,
				},
			});
			return err;
		});
};

export const fetchBudgetByNumber = (number) => async (dispatch) => {
	try {
		const response = await axios.get(`/budget/${number}`);
		const formattedBudget = formatBudgets(response.data);
		const budgetArray = [formattedBudget];
		const budgetObject = keyBy(budgetArray, "_id");

		dispatch({
			type: SET_BUDGET_LIST,
			payload: budgetObject,
		});
		return response.status;
	} catch (err) {
		console.error(err);
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "error",
				message: "Error al obtener el presupuesto.",
			},
		});
		return err;
	}
};

export const fetchBudgetById = (id) => async (dispatch) => {
	try {
		const response = await axios.get(`/budget/getById/${id}`);
		const formattedBudget = formatBudgets(response.data);
		const budgetArray = [formattedBudget];
		const budgetObject = keyBy(budgetArray, "_id");

		dispatch({
			type: SET_BUDGET_LIST,
			payload: budgetObject,
		});

		return response.status;
	} catch (err) {
		console.error(err);
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "error",
				message: "Error al obtener el presupuesto.",
			},
		});
		return err;
	}
};

export const uploadBudgetSignature = (imageDataURL, id) => async (dispatch) => {
	try {
		const response = await axios.post(`${API.budgets.uploadSignature}${id}`, imageDataURL);
		dispatch({ type: BUDGET_FORM_TOOGLE_LOADING });
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "info",
				message: "Firma actualizada.",
			},
		});
		return response.status;
	} catch (err) {
		console.error(err);
		dispatch({ type: BUDGET_FORM_TOOGLE_LOADING });
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "error",
				message: "Error al actualizar la firma.",
			},
		});
		throw err;
	}
};

export const deleteBudgetSignature = (id) => async (dispatch) => {
	try {
		dispatch({ type: BUDGET_FORM_TOOGLE_LOADING });
		const response = await axios.delete(`${API.budgets.deleteSignature}${id}`);
		const budget = formatBudgets(response.data);
		dispatch({ type: UPDATE_BUDGET, payload: budget });
		dispatch({ type: BUDGET_FORM_TOOGLE_LOADING });
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "success",
				message: "Firma eliminada correctamente.",
			},
		});
		return response.status;
	} catch (err) {
		dispatch({ type: BUDGET_FORM_TOOGLE_LOADING });
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "error",
				message: err?.response?.data?.message || "No se pudo eliminar la firma.",
			},
		});
		return err;
	}
};

export const createOffer = (id) => async (dispatch) => {
	try {
		const response = await axios.put(`${API.budgets.createOffer}${id}`);

		const budget = formatBudgets(response.data);
		dispatch({ type: UPDATE_BUDGET, payload: budget });
		dispatch({ type: BUDGET_FORM_TOOGLE_LOADING });
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "info",
				message: "Oferta creada.",
			},
		});
		return response.status;
	} catch (err) {
		const errorMessage = getRequestErrorMessage(err, "Error al crear la oferta.");
		console.error("Error al crear la oferta:", errorMessage);

		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "error",
				message: errorMessage,
			},
		});

		return err;
	}
};

export const acceptOffer = (id) => async (dispatch) => {
	try {
		const response = await axios.put(`${API.budgets.acceptOffer}${id}`);
		const budget = formatBudgets(response.data?.budget || response.data);
		dispatch({ type: UPDATE_BUDGET, payload: budget });
		dispatch({ type: BUDGET_FORM_TOOGLE_LOADING });
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "info",
				message: "Oferta creada.",
			},
		});
		return response.status;
	} catch (err) {
		console.error(err);
		return err;
	}
};

export const acceptOfferAndCreateOfferBC = (id, formClient) => async (dispatch) => {
	try {
		const response = await axios.put(`${API.budgets.acceptOfferAndCreateOfferBC}${id}`, { newClient: formClient });
		const budget = formatBudgets(response.data?.budget || response.data);
		dispatch({ type: UPDATE_BUDGET, payload: budget });
		dispatch({ type: BUDGET_FORM_TOOGLE_LOADING });
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "info",
				message: "Oferta creada.",
			},
		});
		return response.status;
	} catch (err) {
		const errorMessage = getRequestErrorMessage(err, "No se pudo crear la oferta en Business Central. Puedes reintentar.");
		console.error("Error al crear y aceptar la oferta:", errorMessage);
		// Mostrar notificación de error y permitir que el componente llame a reintentar
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "error",
				message: errorMessage,
			},
		});
		return err;
	}
};

export const createOrder = (id) => async (dispatch) => {
	try {
		const response = await axios.put(`${API.budgets.createOrder}${id}`);
		const budget = formatBudgets(response.data);
		dispatch({ type: UPDATE_BUDGET, payload: budget });
		dispatch({ type: BUDGET_FORM_TOOGLE_LOADING });
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "info",
				message: "Pedido creado.",
			},
		});
		return response.status;
	} catch (err) {
		console.error(err);
		// Mostrar mensaje de error del backend si existe
		if (err.response && err.response.data && err.response.data.message) {
			dispatch({
				type: SHOW_NOTIFICATION,
				payload: {
					show: true,
					status: "error",
					message: err.response.data.message,
				},
			});
		}
		return err;
	}
};

export const sendInvoice = (id, facturation, amount) => async (dispatch) => {
	try {
		dispatch({ type: BUDGET_FORM_TOOGLE_LOADING });
		const response = await axios.post(`${API.budgets.sendInvoice}${id}`, { facturation, amount });
		const budget = formatBudgets(response.data);
		dispatch({ type: UPDATE_BUDGET, payload: budget });
		dispatch({ type: BUDGET_FORM_TOOGLE_LOADING });
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "info",
				message: "Factura enviada.",
			},
		});
		return response.status;
	} catch (err) {
		console.error(err);
		dispatch({ type: BUDGET_FORM_TOOGLE_LOADING });
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "error",
				message: getRequestErrorMessage(err, "No se pudo enviar la facturación."),
			},
		});
		return err;
	}
};

export const generateContentWithAI = (prompt, type) => async (dispatch) => {
	try {
		dispatch({ type: BUDGET_FORM_TOOGLE_LOADING });
		const response = await axios.post(`${API.budgets.generateAI}`, { prompt, type });
		dispatch({ type: BUDGET_FORM_TOOGLE_LOADING });
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "success",
				message: "Contenido generado con IA.",
			},
		});
		return response.data.content;
	} catch (err) {
		dispatch({ type: BUDGET_FORM_TOOGLE_LOADING });
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "error",
				message: err.response?.data?.message || "Error generando contenido con IA.",
			},
		});
		console.error(err);
		return null;
	}
};

export const generateCompleteBudgetWithAI = (prompt) => async (dispatch) => {
	try {
		dispatch({ type: BUDGET_FORM_TOOGLE_LOADING });
		const response = await axios.post(`${API.budgets.generateCompleteAI}`, { prompt });
		dispatch({ type: BUDGET_FORM_TOOGLE_LOADING });
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "success",
				message: "Presupuesto completo generado con IA.",
			},
		});
		return response.data;
	} catch (err) {
		dispatch({ type: BUDGET_FORM_TOOGLE_LOADING });
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "error",
				message: err.response?.data?.message || "Error generando presupuesto completo con IA.",
			},
		});
		console.error(err);
		return null;
	}
};

export const improveTextWithAI = (text, fieldType) => async (dispatch) => {
	try {
		const response = await axios.post(`${API.budgets.improveText}`, { text, fieldType });
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "success",
				message: "Texto mejorado con IA.",
			},
		});
		return response.data.improvedText;
	} catch (err) {
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "error",
				message: err.response?.data?.message || "Error mejorando texto con IA.",
			},
		});
		console.error(err);
		return null;
	}
};

export const estimatePriceWithAI = (name, description) => async (dispatch) => {
	try {
		const response = await axios.post(`${API.budgets.estimatePrice}`, { name, description });
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "success",
				message: "Precio estimado con IA.",
			},
		});
		return response.data.estimatedPrice;
	} catch (err) {
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "error",
				message: err.response?.data?.message || "Error estimando precio con IA.",
			},
		});
		console.error(err);
		return null;
	}
};
